"use client";
import { useEffect, useRef, useState } from "react";

import styles from "./sticky-wrapper.module.css";

const StickyWrapper = ({ children }: { children: React.ReactNode }) => {
  const wrapperRef = useRef<HTMLDivElement>(null);
  const [filterBarOffset, setFilterBarOffset] = useState("3rem");

  const filterSize = () => {
    const offsetHeight = wrapperRef.current?.offsetHeight;
    if (offsetHeight && offsetHeight < window.innerHeight) {
      setFilterBarOffset("calc( var(--header-height) + 1vw )");
    } else {
      setFilterBarOffset(`calc(100vh - ${offsetHeight}px)`);
    }
  };

  useEffect(() => {
    if (wrapperRef.current) {
      new ResizeObserver(filterSize).observe(wrapperRef.current);
    }
  }, [wrapperRef]);

  return (
    <div
      className={styles["sticky-wrapper"]}
      ref={wrapperRef}
      style={{ top: "calc( var(--header-height) + 1vw )" }}
    >
      {children}
    </div>
  );
};

export default StickyWrapper;
